function debounce(callback, delay) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      callback.apply(this, arguments)
    }, delay)
  }
}

// Products page tab
if (!customElements.get('hxz-product-tab')) {
  customElements.define(
    'hxz-product-tab',
    class HXZProductTab extends HTMLElement {
      constructor() {
        super()
        this.tabheader = this.querySelector('button')
        this.tabheader.addEventListener('click', this.onTabClick.bind(this))
      }

      onTabClick() {
        this.querySelector('.hxz-tab-content').classList.toggle('expand')
        const svg = this.querySelector('.hxz-menu-plusicon')
        if (svg) {
          svg.classList.toggle('minus')
        }
      }
    }
  )
}

if (!customElements.get('hxz-pd-top-dropdown')) {
  customElements.define(
    'hxz-pd-top-dropdown',
    class HXZPdTopDropdown extends HTMLElement {
      constructor() {
        super()
        this.addEventListener('click', this.openDropdown.bind(this))

        this.querySelector('.dropdown-options').addEventListener(
          'click',
          this.selectVariant.bind(this)
        )
      }

      setSelected(elHtml) {
        this.querySelector('.dropdown-selection').innerHTML = elHtml
      }

      selectVariant(e) {
        if (e.target.closest('.dropdown-option')) {
          let selectEl = e.target.closest('.dropdown-option')
          if (selectEl.classList.contains('-cursor-not-allowed')) {
          } else {
            const selectedValue = selectEl.dataset.value
            let inputEl = document.querySelector(
              `hxz-variant-radios input[value="${selectedValue}"`
            )
            if (inputEl) {
              inputEl.nextElementSibling.click()
              this.setSelected(selectEl.innerHTML)
            }
          }
        }
      }

      openDropdown() {
        this.querySelector('.dropdown-options').classList.toggle('-hidden')
      }
    }
  )
}

class HXZProductGalleryThumbnail extends HTMLElement {
  constructor() {
    super()

    this.currentIndex = 5
    this.querySelector('.hxz-thumbnail-left-wrapper').addEventListener(
      'click',
      this.scrollLeft.bind(this)
    )
    this.querySelector('.hxz-thumbnail-right-wrapper').addEventListener(
      'click',
      this.scrollRight.bind(this)
    )
    this.querySelectorAll('.hxz-product-gallery-sm button').forEach(
      (button, index) => {
        button.addEventListener('click', () => {
          let el = document.querySelectorAll(
            'product-gallery .product-gallery__image-list scroll-carousel div'
          )[index]
          if (el) {
            document
              .querySelector(
                'product-gallery .product-gallery__image-list scroll-carousel'
              )
              .scrollTo({
                left: el.offsetLeft,
                behavior: 'smooth',
              })
          }
        })
      }
    )
  }

  connectedCallback() {
    this.currentIndex = 7
  }

  scrollLeft() {
    const childs = this.querySelectorAll('.hxz-product-gallery-sm button')
    let el = childs[this.currentIndex - 6]
    if (window.innerWidth > 1200) {
      el = childs[this.currentIndex - 8]
    }
    if (!el) return
    if (el.previousElementSibling) {
      this.currentIndex = this.currentIndex - 1
      let scrollPos = {
        left: el.previousElementSibling.offsetLeft,
        behavior: 'smooth',
      }
      if (window.innerWidth > 1200) {
        scrollPos = {
          top: el.previousElementSibling.offsetTop,
          behavior: 'smooth',
        }
      }
      this.querySelector('.hxz-product-gallery-sm').scrollTo(scrollPos)
    } else {
      let scrollPos = {
        left: 0,
        behavior: 'smooth',
      }
      if (window.innerWidth > 1200) {
        scrollPos = {
          top: 0,
          behavior: 'smooth',
        }
      }
      this.querySelector('.hxz-product-gallery-sm').scrollTo(scrollPos)
    }
  }

  scrollRight() {
    const childs = this.querySelectorAll('.hxz-product-gallery-sm button')
    let el = childs[this.currentIndex]
    if (!el) return
    if (el.nextElementSibling) {
      this.currentIndex = this.currentIndex + 1
      let scrollPos = {
        left: el.nextElementSibling.offsetLeft,
        behavior: 'smooth',
      }
      if (window.innerWidth > 1200) {
        scrollPos = {
          top: el.nextElementSibling.offsetTop,
          behavior: 'smooth',
        }
      }
      this.querySelector('.hxz-product-gallery-sm').scrollTo(scrollPos)
    }
  }
}

customElements.define(
  'hxz-product-gallery-thumbnail',
  HXZProductGalleryThumbnail
)

class HxzProductGallery extends HTMLElement {
  constructor() {
    super()
    // 获取链接中的 variant 参数
    const urlParams = new URLSearchParams(window.location.search)
    const variant = urlParams.get('variant')
    if (variant) {
      this.currentId = variant
    }
    this.scrollableEl = null
  }
  connectedCallback() {
    this.mediaMap = this.generateMediaMap()
    this.setCurrentShow()
    this.render()
    this.created = true
    this.listenEvents()
  }
  generateMediaMap() {
    // mediaMap: {id: [{src: '', type: ''}]}
    let mediaMap = {}
    const json = this.querySelector('#hxz-product-gallery-json')
    if (json) {
      mediaMap = JSON.parse(json.textContent)
    }
    return mediaMap
  }
  setCurrentShow() {
    if (!this.currentId) {
      this.currentId = this.getAttribute('current-id')
    }
    if (!this.currentId) {
      this.currentId = Object.keys(this.mediaMap)[0]
    }
  }
  render() {
    const mediaArr = this.mediaMap[this.currentId]
    if (mediaArr) {
      this.renderScrollable(mediaArr)
    }
  }
  // 通过 HXZVariantSelects 组件的 updateURL 触发
  static get observedAttributes() {
    return ['current-id']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'current-id' && this.created) {
      this.currentId = newValue
      this.render()
    }
  }
  // mediaArr [{src: '', type: ''}]
  renderScrollable(mediaArr) {
    if (this.scrollableEl) {
      let scrollable = this.scrollableEl.querySelector('hxz-gallery-scrollable')
      if (scrollable) {
        scrollable.setAttribute('data-str', JSON.stringify(mediaArr))
      }
      let galleryImgs = this.scrollableEl.querySelector('hxz-gallery-imgs')
      if (galleryImgs) {
        galleryImgs.setAttribute('data-str', JSON.stringify(mediaArr))
      }
      return
    }
    const div = document.createElement('div')
    div.className = '-w-full -lg:-grid -lg:-gap-x-6'
    div.style.gridTemplateColumns = '60px 1fr'
    div.innerHTML = `
    <hxz-gallery-scrollable class="-row-start-1 -relative -col-start-2" data-str='${JSON.stringify(
      mediaArr
    )}'>
    </hxz-gallery-scrollable>
    <hxz-gallery-imgs class="-h-full -row-start-1 -col-start-1" data-str='${JSON.stringify(
      mediaArr
    )}'></hxz-gallery-imgs>
    `
    this.appendChild(div)
    this.scrollableEl = div
  }
  listenEvents() {
    this.addEventListener('img-click', e => {
      e.stopPropagation()
      const scrollable = this.querySelector('hxz-gallery-scrollable')
      if (scrollable) {
        scrollable.showIndex(e.detail)
      }
    })
  }
}

class HxzGalleryScrollable extends HTMLElement {
  constructor() {
    super()
    this.created = false
  }
  connectedCallback() {
    this.render()
    this.created = true
  }
  render() {
    const mediaStr = this.getAttribute('data-str')
    let hxzProductGallery = this.closest('hxz-product-gallery')
    let virtualTemplate = hxzProductGallery.querySelector(
      '#hxz-virtual-template'
    )
    if (virtualTemplate) {
      virtualTemplate = virtualTemplate.content
    } else {
      virtualTemplate = null
    }
    if (mediaStr) {
      const mediaArr = JSON.parse(mediaStr)
      if (mediaArr instanceof Array) {
        const mediaHtml = mediaArr
          .map(item => {
            if (item.type === 'image') {
              return `<div class="-mr-24 -w-full -h-full -flex-none">
            <hxz-image src="${item.src}" ratio="0.5" max-width="1080"></hxz-image>
          </div>`
            } else if (item.type === 'video') {
              const target = this.getVideo(item.id)
              if (target) {
                return `<div class="-mr-24 -w-full -h-full -flex-none -flex-center">
                    <video controls="controls" loop="loop" preload="metadata" poster="${target.poster}">
                      <source src="${target.url}" type="video/mp4">
                      <img src="${target.poster}">
                    </video>
                </div>`
              }
              return ''
            }
          })
          .join('')
        if (this.created) {
          this.querySelector('.scrollable').innerHTML = mediaHtml
        } else {
          this.innerHTML = `<div class="-w-full -aspect-[4/5] -overflow-hidden container-scrollable">
            <div class="scrollable -w-full -h-full -flex -flex-nowrap -overflow-auto -relative">
              ${mediaHtml}
            </div>
          </div>`
          let container = this.querySelector('.container-scrollable')
          if (virtualTemplate) {
            container.appendChild(virtualTemplate.cloneNode(true))
          }
        }
      }
    }
  }
  showIndex(index) {
    const el = this.querySelector('.scrollable').children[index]
    if (el) {
      this.querySelector('.scrollable').scrollTo({
        left: el.offsetLeft,
        behavior: 'smooth',
      })
    }
  }
  getVideo(id) {
    const parent = this.closest('hxz-product-gallery')
    const template = parent.querySelector('template')
    if (!template) return null
    const videoEl = template.content.querySelector(`[id="${id}"]`)
    if (videoEl) {
      const url = videoEl.querySelector('source').src
      const poster = videoEl.querySelector('img').src
      return {
        url,
        poster,
      }
    }
    return null
  }
  static get observedAttributes() {
    return ['data-str']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-str' && this.created) {
      this.currentId = newValue
      this.render()
    }
  }
}

class HxzGalleryImgs extends HTMLElement {
  constructor() {
    super()
    this.created = false
  }
  connectedCallback() {
    this.render()
    this.className = '-w-full'
    this.created = true
  }
  render() {
    const mediaStr = this.getAttribute('data-str')
    if (mediaStr) {
      const mediaArr = JSON.parse(mediaStr)
      if (mediaArr instanceof Array) {
        const images = mediaArr.map(item => {
          if (item.type == 'image') {
            return item.src
          }
          if (item.type == 'video') {
            const target = this.getVideo(item.id)
            if (target) {
              return target.poster
            }
          }
          return ''
        })
        if (images.length <= 7) {
          this.createImage(images, '0')
          this.createImage(images, '1')
        } else {
          const swiper = document.createElement('hxz-swiper')
          const swiperV = document.createElement('hxz-swiper')
          swiper.setAttribute('show-num', 7)
          swiper.setAttribute('gap', '16px')
          swiper.className = '-w-full -hidden -mdx:-block -lg:-hidden'
          swiperV.setAttribute('show-num', 7)
          swiperV.setAttribute('gap', '10px')
          swiperV.setAttribute('direction', '1')
          swiperV.className = '-w-full -hidden -lg:-block'
          swiperV.style.height = '585px'
          swiper.appendChild(this.createList(images))
          swiperV.appendChild(this.createList(images))
          this.createSwiper(swiper, 0)
          this.createSwiper(swiperV, 1)
        }
      }
    }
  }
  createList(images) {
    const imagesFrame = document.createDocumentFragment()
    for (let i = 0; i < images.length; i++) {
      const img = document.createElement('hxz-image')
      img.setAttribute('src', images[i])
      img.setAttribute('max-width', '120')
      img.style.cursor = 'pointer'
      img.addEventListener('click', () => {
        this.bindClickEvent(i)
      })
      // const div = document.createElement('div')
      // div.className = '-w-full -aspect-[4/5]'
      // div.appendChild(img)
      imagesFrame.appendChild(img)
    }
    return imagesFrame
  }
  createImage(images, direction) {
    const makeImg = () => {
      const fragment = document.createDocumentFragment()
      for (let i = 0; i < images.length; i++) {
        const img = document.createElement('hxz-image')
        img.setAttribute('src', images[i])
        img.setAttribute('max-width', '120')
        img.style.cursor = 'pointer'
        img.addEventListener('click', () => {
          this.bindClickEvent(i)
        })
        const div = document.createElement('div')
        div.style.width = '52px'
        div.className = '-aspect-[4/5] -flex-none'
        div.appendChild(img)
        fragment.appendChild(div)
      }
      return fragment
    }
    if (direction == 0) {
      const div = document.createElement('div')
      div.className =
        '-w-full direction-zero -hidden -mdx:-flex -lg:-hidden -mt-26 -item-center -justify-center -gap-x-4'
      div.appendChild(makeImg())
      let oldContainer = this.querySelector('.direction-zero')
      if (oldContainer) {
        this.replaceChild(div, oldContainer)
      } else {
        this.appendChild(div)
      }
    }
    if (direction == 1) {
      const div = document.createElement('div')
      div.className =
        '-hidden direction-one -w-[52px] -h-max -lg:-flex -mr-26 -item-center  -flex-col -justify-center -gap-y-4'
      div.appendChild(makeImg())
      let oldContainer = this.querySelector('.direction-one')
      if (oldContainer) {
        this.replaceChild(div, oldContainer)
      } else {
        this.appendChild(div)
      }
    }
  }
  createSwiper(swiper, direction) {
    if (direction == 0) {
      const left = document.createElement('div')
      left.style.marginRight = '12px'
      left.innerHTML = `<svg class="iconpark-icon -cursor-pointer"><use href="#Frame1517-1"></use></svg>`
      const right = document.createElement('div')
      right.style.marginLeft = '12px'
      right.innerHTML = `<svg style="transform:rotate(180deg)" class="iconpark-icon -cursor-pointer"><use href="#Frame1517-1"></use></svg>`
      const container = document.createElement('div')
      container.className =
        'direction-zero -w-full -flex-center -pt-26 -lg:-hidden'
      container.appendChild(left)
      container.appendChild(swiper)
      container.appendChild(right)
      let oldContainer = this.querySelector('.direction-zero')
      if (oldContainer) {
        this.replaceChild(container, oldContainer)
      } else {
        this.appendChild(container)
      }
      left.addEventListener('click', () => {
        swiper.prev()
      })
      right.addEventListener('click', () => {
        swiper.next()
      })
    }
    if (direction == 1) {
      const top = document.createElement('div')
      top.style.marginBottom = '12px'
      top.innerHTML = `<svg style="transform:rotate(90deg)" class="iconpark-icon -cursor-pointer"><use href="#Frame1517-1"></use></svg>`
      const bottom = document.createElement('div')
      bottom.style.marginTop = '12px'
      bottom.innerHTML = `<svg style="transform:rotate(-90deg)" class="iconpark-icon -cursor-pointer"><use href="#Frame1517-1"></use></svg>`
      const container = document.createElement('div')
      container.className =
        '-w-full direction-one -h-max -flex-col -hidden -lg:-flex -items-center -justify-center'
      container.appendChild(top)
      container.appendChild(swiper)
      container.appendChild(bottom)
      let oldContainer = this.querySelector('.direction-one')
      if (oldContainer) {
        this.replaceChild(container, oldContainer)
      } else {
        this.appendChild(container)
      }
      top.addEventListener('click', () => {
        swiper.prev()
      })
      bottom.addEventListener('click', () => {
        swiper.next()
      })
    }
  }
  getVideo(id) {
    const parent = this.closest('hxz-product-gallery')
    const template = parent.querySelector('template')
    if (!template) return null
    const videoEl = template.content.querySelector(`[id="${id}"]`)
    if (videoEl) {
      const url = videoEl.querySelector('source').src
      const poster = videoEl.querySelector('img').src
      return {
        url,
        poster,
      }
    }
    return null
  }
  bindClickEvent(index) {
    this.dispatchEvent(
      new CustomEvent('img-click', {
        detail: index,
        bubbles: true, // 允许冒泡
      })
    )
  }
  static get observedAttributes() {
    return ['data-str']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-str' && this.created) {
      this.render()
    }
  }
}

class HxzInfoScrollable extends HTMLElement {
  constructor() {
    super()
    // 获取链接中的 variant 参数
    const urlParams = new URLSearchParams(window.location.search)
    const variant = urlParams.get('variant')
    if (variant) {
      this.currentId = variant
    }
  }
  connectedCallback() {
    this.mediaMap = this.generateMediaMap()
    this.setCurrentShow()
    this.render()
    this.created = true
  }
  generateMediaMap() {
    // mediaMap: {id: [{src: '', type: ''}]}
    let mediaMap = {}
    const json = this.querySelector('#hxz-info-scrollable-json')
    if (json) {
      mediaMap = JSON.parse(json.textContent)
    }
    return mediaMap
  }
  render() {
    const mediaArr = this.mediaMap[this.currentId]
    if (mediaArr) {
      this.renderScrollable(mediaArr)
    }
  }
  renderScrollable(mediaArr) {
    const fragment = document.createDocumentFragment()
    const div = document.createElement('div')
    div.className =
      '-mt-12 -flex -flex-nowrap -overflow-x-auto -gap-2.5 hxz-pd-medias'

    const mediaHtml = mediaArr
      .map(item => {
        if (item.type === 'image') {
          return `<div class="-shrink-0 snap-center -flex-center" style="width:52vw">
            <hxz-image src="${item.src}" ratio="0.5" max-width="850"></hxz-image>
          </div>`
        } else if (item.type === 'video') {
          const target = this.getVideo(item.id)
          if (target) {
            return `<div class="-shrink-0 snap-center -flex-center" style="width:52vw">
                    <video controls="controls" loop="loop" preload="metadata" poster="${target.poster}">
                      <source src="${target.url}" type="video/mp4">
                      <img src="${target.poster}">
                    </video>
                </div>`
          }
          return ''
        }
      })
      .join('')
    div.innerHTML = mediaHtml
    fragment.appendChild(div)

    if (this.created) {
      const oldChild = this.children[this.children.length - 1]
      this.replaceChild(fragment, oldChild)
    } else {
      this.appendChild(fragment)
    }
  }
  getVideo(id) {
    const template = this.querySelector('template')
    if (!template) return null
    const videoEl = template.content.querySelector(`[id="${id}"]`)
    if (videoEl) {
      const url = videoEl.querySelector('source').src
      const poster = videoEl.querySelector('img').src
      return {
        url,
        poster,
      }
    }
    return null
  }
  setCurrentShow() {
    if (!this.currentId) {
      this.currentId = this.getAttribute('current-id')
    }
    if (!this.currentId) {
      this.currentId = Object.keys(this.mediaMap)[0]
    }
  }
  // 通过 HXZVariantSelects 组件的 updateURL 触发
  static get observedAttributes() {
    return ['current-id']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'current-id' && this.created) {
      this.currentId = newValue
      this.render()
    }
  }
}

customElements.define('hxz-gallery-scrollable', HxzGalleryScrollable)
customElements.define('hxz-gallery-imgs', HxzGalleryImgs)
customElements.define('hxz-product-gallery', HxzProductGallery)
customElements.define('hxz-info-scrollable', HxzInfoScrollable)

/**
 * 新版产品选择器组件
 * @field {0|1|2} data-type 选择器类型，0:单选，1:多选sku， 2:多选spu
 *
 */
class HxzVariantBlock extends EventBusHTMLElement {
  constructor() {
    super()
    this._selectedVariant = null
  }
  get selectedVariant() {
    return this._selectedVariant
  }
  set selectedVariant(value) {
    this._selectedVariant = value
    this.reloadImages()
    // 在url上加上variant参数
    let urlParams = new URLSearchParams(window.location.search)
    urlParams.set('variant', value)
    let newUrl = `${window.location.origin}${
      window.location.pathname
    }?${urlParams.toString()}`
    window.history.pushState({}, 0, newUrl)
    this.valueChangedCallback()
  }
  connectedCallback() {
    this.type = this.getAttribute('data-type') || 0
    this.productId = this.getAttribute('data-product-id')
    this._selectedVariant = this.getAttribute('data-current-variant')
    this.eventBind()
  }
  valueChangedCallback() {
    const value = this.getValue()
    this.eventEmit(window.hxzEventMap.variantSelectChange(this.productId), {
      selectedVariant: this.selectedVariant,
      variants: value,
    })
  }
  eventBind() {
    // 接受数量变化事件
    this.addEventListener('quantity-change', e => {
      e.stopPropagation()
      // 向上抛
      this.valueChangedCallback()
    })
    // 主动接受其他组件获取值的事件
    this.eventOn(window.hxzEventMap.variantSelectGet(this.productId), data => {
      let value = this.getValue()
      return {
        ...data,
        selectedVariant: this.selectedVariant,
        variants: value, // 不需要排除，末端根据需要排除
      }
    })
    // 监听option选中事件
    this.eventOn(
      window.hxzEventMap.variantOptionClick(this.productId),
      value => {
        if (this.selectedVariant != value.variantId) {
          this.changeTitle(value.title)
          this.selectedVariant = value.variantId
        }
      }
    )
    // 监听展开事件
    let toggleBtn = this.querySelector('.variant-toggle')
    if (toggleBtn) {
      this.toggleBtn = toggleBtn
      toggleBtn.addEventListener('click', () => {
        let container = this.querySelector('.variant-container')
        if (container) {
          let isExpend = container.hasAttribute('data-expend')
          if (isExpend) {
            container.style.maxHeight = 'calc(60px * var(--scale))'
          } else {
            container.style.maxHeight = 'max-content'
          }
          container.toggleAttribute('data-expend')
          toggleBtn.classList.toggle('data-expend')
        }
      })
    }
    // 加购事件
    this.eventOn(window.hxzEventMap.productAddCart(this.productId), data => {
      let value = this.getValue()
      return {
        ...data,
        variants: value.filter(v => v.available && v.quantity > 0),
      }
    })
    // 监听variant filter变化
    this.eventOn(
      window.hxzEventMap.variantFilterChange(this.productId),
      data => {
        this.filtersChange(data)
      }
    )
    // 监听variant filter expand
    let filterExpand = this.querySelector('.filter-expand-icon')
    if (filterExpand) {
      filterExpand.addEventListener('click', () => {
        let expanded = true
        if (filterExpand.hasAttribute('data-expand')) {
          filterExpand.removeAttribute('data-expand')
          expanded = false
        } else {
          filterExpand.setAttribute('data-expand', '')
        }
        if (expanded) {
          filterExpand.style.transform = 'rotate(180deg)'
        } else {
          filterExpand.style.transform = 'rotate(0deg)'
        }
        this.eventEmit(
          window.hxzEventMap.variantFilterExpand(this.productId),
          expanded
        )
      })
    }
    // 监听url 的 variant 初始参数
    const urlParams = new URLSearchParams(window.location.search)
    const variantId = urlParams.get('variant')
    if (variantId) {
      this.selectedVariant = variantId
    }
  }
  changeTitle(title) {
    let titleEl = this.querySelector('.variant-title')
    if (titleEl) {
      titleEl.innerText = title
    }
  }
  reloadImages() {
    const hxzProductGallery = document.querySelector('hxz-product-gallery')
    if (hxzProductGallery) {
      hxzProductGallery.setAttribute('current-id', this.selectedVariant)
    }
    const hxzInfoScrollable = document.querySelector('hxz-info-scrollable')
    if (hxzInfoScrollable) {
      hxzInfoScrollable.setAttribute('current-id', this.selectedVariant)
    }
  }
  /**
   * 获取选择器的值
   * @returns {Array<{variantId:string,quantity:number,price:string,available:boolean}>} 返回variant列表
   */
  getValue() {
    let quantity = 1
    if (this.type == '1' || this.type == '2') {
      quantity = this.querySelector('hxz-quantity-button').getValue()
    }
    let options = this.querySelectorAll('hxz-variant-option')
    if (options.length > 0) {
      // 多sku的情况
      let target = Array.from(options).find(
        option => option.getAttribute('data-variant-id') == this.selectedVariant
      )
      if (target) {
        let value = {}
        if (target.getValue) {
          value = target.getValue()
        } else {
          value = {
            variantId: target.getAttribute('data-variant-id'),
            available: target.getAttribute('data-available') == 'true',
            price: target.getAttribute('data-price'),
            sku: target.getAttribute('data-sku'),
          }
        }
        return [
          {
            ...value,
            quantity: quantity,
          },
        ]
      }
      return []
    } else {
      // 单sku情况
      return [
        {
          variantId: this.selectedVariant,
          quantity: quantity,
          available: !!this.selectedVariant,
          price: this.getAttribute('data-price'),
          sku: this.getAttribute('data-sku'),
        },
      ]
    }
  }
  filtersChange(filters) {
    let filterValue = filters.map(f => f.value).filter(v => v != 'all')
    let data = this.eventReduce(
      window.hxzEventMap.variantFilterGet(`variant-block-${this.productId}`),
      { count: 0, selectedCallback: null, filter: filterValue }
    )
    if (data.selectedCallback) {
      data.selectedCallback()
    }
    let sizeEl = this.querySelector('.variants-size')
    if (sizeEl) {
      sizeEl.innerText = data.count
    }
    if (this.toggleBtn) {
      if (data.count > 7) {
        this.toggleBtn.classList.remove('-hidden')
      } else {
        this.toggleBtn.classList.add('-hidden')
      }
    }
  }
}

customElements.define('hxz-variant-block', HxzVariantBlock)

class HxzVariantFilter extends EventBusHTMLElement {
  constructor() {
    super()
    this.filter = [] // {label:string, value:string}[]
    this.productId = this.getAttribute('data-product-id')
  }
  connectedCallback() {
    this.bindEvents()
  }
  bindEvents() {
    let buttons = this.querySelectorAll('button.filter-option')
    if (buttons.length > 0) {
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          let label = button.getAttribute('label')
          let value = button.getAttribute('value')
          this.changeFilter({ label, value })
        })
      })
    }
    this.eventOn(
      window.hxzEventMap.variantFilterExpand(this.productId),
      expanded => {
        if (expanded) {
          this.style.height = 'max-content'
        } else {
          this.style.height = '0px'
        }
      }
    )
  }
  changeFilter(filter) {
    let target = this.filter.find(f => f.label == filter.label)
    if (target) {
      if (target.value == filter.value) {
        return
      } else {
        this.toggleStyle(target, filter.value)
        target.value = filter.value
      }
    } else {
      this.toggleStyle({ label: filter.label, value: 'all' }, filter.value)
      this.filter.push(filter)
    }
    this.eventEmit(
      window.hxzEventMap.variantFilterChange(this.productId),
      this.filter
    )
  }
  toggleStyle(target, value) {
    let button = this.querySelector(
      `button.filter-option[label="${target.label}"][value="${target.value}"]`
    )
    if (button) {
      button.classList.remove('active')
    }
    button = this.querySelector(
      `button.filter-option[label="${target.label}"][value="${value}"]`
    )
    if (button) {
      button.classList.add('active')
    }
  }
}

customElements.define('hxz-variant-filter', HxzVariantFilter)

/**
 * 新版产品bundle选择器组件
 * @field {1|2} data-type bundle类型，1:sku，2:spu
 * @field {string} data-product-id 当前产品id
 */
class HxzBundleBlock extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id')
    this.type = this.getAttribute('data-type') || 1
    this.checked = this.classList.contains('checked') || false
    this.evenBind()
  }
  evenBind() {
    // 监听产品卡片的变化
    this.addEventListener('select-card-change', e => {
      e.stopPropagation()
      this.valueChangedCallback()
    })
    // 监听加购方式事件
    let checkbox = this.querySelector('.bundle_checkbox')
    if (checkbox) {
      checkbox.addEventListener('click', () => {
        if (this.type == 2) {
          this.checked = !this.checked
          if (this.checked) {
            this.classList.add('checked')
          } else {
            this.classList.remove('checked')
          }
          setTimeout(() => {
            this.valueChangedCallback()
          }, 0)
        }
      })
    }
    // 卡片点击事件
    if (this.type == 1) {
      this.addEventListener('select-card-click', e => {
        e.stopPropagation()
        let currentVariantId = e.detail
        this.reloadImages(currentVariantId)
      })
    }
    // 主动接受其他组件获取值的事件
    this.eventOn(window.hxzEventMap.variantSelectGet(this.productId), data => {
      let value = this.getValue()
      return {
        ...data,
        bundle: value, // 不需要排除，末端根据需要排除
      }
    })
    // 加购事件
    this.eventOn(window.hxzEventMap.productAddCart(this.productId), data => {
      let value = this.getValue()
      return {
        ...data,
        bundle: value.filter(v => v.available && v.quantity > 0),
      }
    })
  }
  // 在type=1时更新左侧图片
  reloadImages(variantId) {
    const value = this.getValue()
    this.eventEmit(window.hxzEventMap.variantSelectChange(this.productId), {
      selectedVariant: variantId,
      bundle: value,
    })
  }
  valueChangedCallback() {
    const value = this.getValue()
    // 改变展示的价格
    this.updatePrice(value)
    this.eventEmit(window.hxzEventMap.bundleSelectChange(this.productId), {
      bundle: value,
    })
  }
  updatePrice(value) {
    let price = value.reduce((acc, cur) => {
      return acc + getPriceFromFormat(cur.price) * cur.quantity
    }, 0)
    let priceEl = this.querySelector('.bundle_price')
    if (priceEl) {
      if (value.length > 0 && price > 0) {
        price = (Math.round(price * 100) / 100).toFixed(2)
        let originalFormat = value[0].price
        let originalPrice = originalFormat.replace(/[^0-9.,]/g, '')
        let currentPrice = originalFormat.replace(originalPrice, price)
        priceEl.innerText = currentPrice
      } else {
        priceEl.innerText = ''
      }
    }
  }
  /**
   * 获取选择器的值
   * @returns {Array<{variantId:string,quantity:number,price:string,available:boolean}>} 返回variant列表
   */
  getValue() {
    if (!this.checked) return []
    let selectCard = this.querySelectorAll('hxz-select-card')
    if (selectCard.length > 0) {
      let values = []
      selectCard.forEach(card => {
        let value = card.getValue()
        if (value.available) {
          values.push(value)
        }
      })
      return values
    } else {
      console.log('card empty')
      return []
    }
  }
}

customElements.define('hxz-bundle-block', HxzBundleBlock)

/**
 * 新版礼品选择器组件
 * @field {1|2} data-step-type 阶梯类型，1:金额，2:数量
 *
 */
class HxzGiftBlock extends EventBusHTMLElement {
  constructor() {
    super()
    this.type = 1
    this.steps = []
    this.unlockNum = 0
    this.productId = null
    this.currentCard = null
    this.userOperate = false
    this.currentStep = -1
    this.unlockMax = -1
  }
  connectedCallback() {
    this.type = this.getAttribute('data-step-type') || 1
    this.productId = this.getAttribute('data-product-id')
    let stepString = this.getAttribute('data-step-value') || ''
    this.steps = stepString.split(',').map(s => Number(s))
    this.eventBind()
    setTimeout(() => {
      let value = this.eventReduce(
        window.hxzEventMap.variantSelectGet(this.productId),
        {}
      )
      let variants = []
      if (value.variants && value.variants.length > 0) {
        variants = [...variants, ...value.variants]
      }
      if (value.bundle && value.bundle.length > 0) {
        variants = [...variants, ...value.bundle]
      }
      this.refresh(variants)
    }, 0)
  }
  eventBind() {
    // 监听选择器值的变化
    const productChange = value => {
      let variants = []
      if (value.variants && value.variants.length > 0) {
        variants = [...variants, ...value.variants]
      }
      if (value.bundle && value.bundle.length > 0) {
        variants = [...variants, ...value.bundle]
      }
      this.refresh(variants)
    }

    this.eventOn(window.hxzEventMap.variantSelectChange(this.productId), () => {
      let data = this.eventReduce(
        window.hxzEventMap.productAddCart(this.productId),
        {}
      )
      productChange(data)
    })
    // 监听bundle值的变化
    this.eventOn(window.hxzEventMap.bundleSelectChange(this.productId), () => {
      let data = this.eventReduce(
        window.hxzEventMap.productAddCart(this.productId),
        {}
      )
      productChange(data)
    })
    // 处理选中事件
    this.cards = this.querySelectorAll('hxz-select-card')
    this.cards.forEach((card, index) => {
      let selectIcon = this.cards[index].querySelector('.select-icon')
      if (selectIcon) {
        selectIcon.addEventListener('click', () => {
          this.userOperate = true
          this.currentCard = card
          this.select(card, index)
          this.enable(this.currentStep)
          this.currentStep = index
        })
      }
    })
    // 加购事件
    this.eventOn(window.hxzEventMap.productAddCart(this.productId), data => {
      let value = this.getValue()
      return {
        ...data,
        gift: value,
      }
    })
  }
  // value:Array<{variantId:string,quantity:number,price:string}>
  refresh(value) {
    let currentPrice = value.reduce((acc, cur) => {
      return acc + getPriceFromFormat(cur.price) * cur.quantity
    }, 0)
    let unlockNum = 0,
      maxGiftIndex = -1
    for (let i = 0; i < this.steps.length; i++) {
      if (this.type == 1) {
        let price = getCurrentPrice(this.steps[i])
        if (currentPrice >= price) {
          unlockNum++
          this.enable(i)
          maxGiftIndex = i
        } else {
          this.disable(i)
        }
      } else {
        let quantity = value.reduce((acc, cur) => {
          let val = cur.quantity
          if (cur.available == false) {
            val = 0
          }
          return acc + val
        }, 0)
        // 数量
        if (quantity >= this.steps[i]) {
          unlockNum++
          this.enable(i)
          maxGiftIndex = i
        } else {
          this.disable(i)
        }
      }
    }
    let unlockEl = this.querySelector('.unlock-num')
    if (maxGiftIndex == -1) {
      this.currentCard = null
    } else {
      this.checkMaxGift(maxGiftIndex)
    }
    if (unlockEl) {
      unlockEl.innerText = maxGiftIndex + 1
    }
  }
  // 卡片变成不可选状态
  disable(index) {
    let cards = this.cards
    let el = cards[index]
    if (el) {
      let mask = el.querySelector('.lock-mask')
      let selectedIcon = el.querySelector('.selected-icon')
      let selectIcon = el.querySelector('.select-icon')
      if (mask && selectedIcon && selectIcon) {
        mask.classList.remove('-hidden')
        selectedIcon.classList.add('-hidden')
        selectIcon.classList.add('-hidden')
      }
    }
  }
  // 卡片恢复未选中状态
  enable(index) {
    let cards = this.cards
    let el = cards[index]
    if (el) {
      let mask = el.querySelector('.lock-mask')
      let selectedIcon = el.querySelector('.selected-icon')
      let selectIcon = el.querySelector('.select-icon')
      if (mask && selectedIcon && selectIcon) {
        mask.classList.add('-hidden')
        selectedIcon.classList.add('-hidden')
        selectIcon.classList.remove('-hidden')
      }
    }
  }
  // 卡片变为选中状态
  select(el, index) {
    let selectedIcon = el.querySelector('.selected-icon')
    let selectIcon = el.querySelector('.select-icon')
    if (selectedIcon && selectIcon) {
      selectedIcon.classList.remove('-hidden')
      selectIcon.classList.add('-hidden')
    }
    let swiper = this.querySelector('hxz-bundle-swiper')
    if (swiper) {
      // 礼品默认3个一组
      let max = this.cards.length - 3
      let slideIndex = index > max ? max : index
      swiper.changeActiveIndex(slideIndex)
    }
  }
  checkMaxGift(index) {
    let cards = this.cards
    let target = cards[index]
    if (target) {
      let value = target.getValue()
      if (value.available) {
        let fn = () => {
          this.currentCard = target
          this.select(target, index)
          this.currentStep = index
        }
        if (this.userOperate) {
          if (this.currentStep > index) {
            fn()
            let text = this.getAttribute('data-toast-sub')
            if (text) {
              showToast(text)
            }
            this.userOperate = false
          } else {
            let text = this.getAttribute('data-toast-add')
            if (text && index > this.unlockMax) {
              showToast(text)
            }
            this.select(this.cards[this.currentStep], this.currentStep)
          }
        } else {
          fn()
        }
        this.unlockMax = index
      }
    }
  }
  /**
   * 获取礼物的值
   * @returns {Array<{variantId:string,quantity:number,price:number}>} 返回variant列表
   */
  getValue() {
    if (this.currentCard == null) {
      return null
    }
    let value = this.currentCard.getValue()
    if (this.currentStep == -1 || !value.available) {
      return null
    }
    return { variantId: value.variantId, quantity: 1 }
  }
}

customElements.define('hxz-gift-block', HxzGiftBlock)

// 处理国际价格 $1,234.12 USD -> 1234.12
function getPriceFromFormat(price) {
  let num = price.replace(/[^0-9.,]/g, '')
  let reverseArray = num.split('').reverse()
  for (let i = 0; i < reverseArray.length; i++) {
    if (reverseArray[i] == ',') {
      if (i <= 2) {
        reverseArray[i] = '.'
      } else {
        reverseArray[i] = ''
      }
    } else if (reverseArray[i] == '.') {
      if (i > 2) {
        reverseArray[i] = ''
      }
    }
  }
  return reverseArray.reverse().join('')
}

/**
 * 新版产品详情页加购block
 */
class HxzAddButtonBlock extends EventBusHTMLElement {
  constructor() {
    super()
    this.isGift = false
    this.productId = null
  }
  connectedCallback() {
    this.isGift = this.hasAttribute('data-is-gift')
    this.available = this.hasAttribute('data-available')
    this.currentAvailable = this.available // 当前按钮加购状态
    this.productId = this.getAttribute('data-product-id')
    this.eventBind()
    this.init()
  }
  eventBind() {
    this.button = this.querySelector('button.submit')
    this.disableButton = this.querySelector('button.submit-disable')
    if (this.button && !this.button.hasAttribute('disabled')) {
      this.button.addEventListener('click', () => {
        if (!this.currentAvailable) return
        // 获取各种数据
        let data = this.eventReduce(
          window.hxzEventMap.productAddCart(this.productId),
          {}
        )
        this.submitCart(data)
      })
    }
  }
  init() {
    if (this.isGift) {
      // 获取链接上 discount-code 字段
      const urlParams = new URLSearchParams(window.location.search)
      const discountCode = urlParams.get('discount-code')
      if (!discountCode) {
        return this.parentNode.remove()
      } else {
        let variantStr = this.getAttribute('data-variant-str')
        if (variantStr) {
          let variantIds = variantStr.split(',').filter(i => i)
          window.hxzCartHandle.addReflect(
            variantIds,
            this.productId + '_add_button'
          )
        }
      }
    }
    if (this.available) {
      // 获取当前variant 是否售罄
      const getCurrentVariants = debounce(() => {
        let value = this.eventReduce(
          window.hxzEventMap.variantSelectGet(this.productId),
          {}
        )
        let variants = []
        // 组套
        if (value.singleBundle) {
          // 组套本身不可卖
          if (value.singleBundle.available) {
            // 组套内部不可卖
            let noEffect = value.singleBundle.bundle.find(v => !v.available)
            if (!noEffect) {
              variants = [
                {
                  variantId: value.singleBundle.variantId,
                  quantity: 1,
                  available: true,
                },
              ]
            }
          }
        } else {
          if (value.variants && value.variants.length > 0) {
            variants = [...variants, ...value.variants]
          }
          if (value.bundle && value.bundle.length > 0) {
            variants = [...variants, ...value.bundle]
          }
        }
        this.changeButton(variants)
      }, 100)
      // 监听变体变化
      this.eventOn(
        window.hxzEventMap.variantSelectChange(this.productId),
        () => {
          getCurrentVariants()
        }
      )
      // 监听bundle变化
      this.eventOn(
        window.hxzEventMap.bundleSelectChange(this.productId),
        () => {
          getCurrentVariants()
        }
      )
      setTimeout(() => {
        getCurrentVariants()
      }, 0)
    } else {
      this.button?.classList.add('-hidden')
      this.disableButton.classList.remove('-hidden')
    }
  }
  /**
   * @param {Array<{variantId:string,quantity:number,price:string,available:boolean}>} value 传入的参数
   */
  changeButton(value) {
    let effectVariant = value.find(v => v.available)
    if (effectVariant) {
      this.button.classList.remove('-hidden')
      this.disableButton.classList.add('-hidden')
      let available = value.find(v => v.available && v.quantity > 0)
      if (available) {
        this.button.style.backgroundColor = '#003b4a'
        this.button.style.cursor = 'pointer'
        this.button.style.color = 'white'
        this.currentAvailable = true
      } else {
        this.button.style.backgroundColor = 'rgb(229,231,235)'
        this.button.style.cursor = 'not-allowed'
        this.button.style.color = 'black'
        this.currentAvailable = false
      }
    } else {
      this.button.classList.add('-hidden')
      this.disableButton.classList.remove('-hidden')
    }
  }
  /**
   * @param {
   *  {
   *    gift:{variantId:string,quantity:number},
   *    variants:[{variantId:string,quantity:number}],
   *    bundle:[{variantId:string,quantity:number}],
   *    discountCode:string
   *  } |
   *  {
   *    singleBundle:{
   *      variantId:string,
   *      available:boolean,
   *      bundle:[{variantId:string,available:boolean,productName:string,variantName:string}]
   *    },
   *    discountCode:string
   *  }
   * } data
   */
  submitCart(data) {
    if (data.singleBundle) {
      this.bundleAdd(data.singleBundle)
    } else {
      this.normalAdd(data)
    }
  }
  // 组套产品加购
  bundleAdd(data) {
    let quantity = 1
    let el = this.querySelector('hxz-quantity-button')
    if (el) {
      quantity = el.getValue()
    }
    let titleJoin = data.bundle
      .map(v => `${v.productName}-${v.variantName}`)
      .join('|')
    let variantIds = data.bundle.map(v => v.variantId)
    window.addToCart([
      {
        quantity,
        id: data.variantId,
        properties: {
          _isSet: true,
          _setItems: variantIds,
          _customizeSetItems: titleJoin,
        },
      },
    ])
  }
  // 单品加购
  normalAdd(data) {
    // 最终加购的变体列表
    let variants = []
    if (data.variants && data.variants.length > 0) {
      variants = [...variants, ...data.variants]
    }
    if (data.bundle && data.bundle.length > 0) {
      variants = [...variants, ...data.bundle]
    }
    if (variants.length === 0) {
      return
    }
    let quantity = 1
    if (!this.isGift) {
      let el = this.querySelector('hxz-quantity-button')
      if (el) {
        quantity = el.getValue()
      }
    } else {
      window.hxzCartHandle.addLimit(
        [
          {
            variantId: variants[0].variantId,
            lowercase: 0,
            excludeBundle: true,
            limit: 1,
          },
        ],
        this.productId + '_add_button'
      )
    }
    let codeApply = () => {}
    if (data.discountCode) {
      codeApply = () => {
        window.applyCode(data.discountCode, this.productId)
      }
    }
    // 确认是否有礼品
    if (data.gift) {
      // 组bundle加购
      this.makeBundle(
        { variants, gift: data.gift, repeat: quantity },
        codeApply
      )
    } else {
      // 直接加购
      let update = variants.reduce((acc, cur) => {
        acc[cur.variantId] = quantity * cur.quantity
        return acc
      }, {})
      window.cartChangeBefore(update, 'add').then(() => {
        codeApply()
      })
    }
  }
  /**
   * @param {{gift:{variantId:string,quantity:number},variants:[{variantId:string,quantity:number}]}} data
   */
  makeBundle({ variants, gift, repeat }, callback) {
    let items = []
    let timeStamp = Date.now(),
      count = 0
    for (let i = 0; i < repeat; i++) {
      let adds = []
      variants.forEach(item => {
        adds.push({
          id: item.variantId,
          quantity: Number(item.quantity || 1),
          properties: {
            _bundleStamp: timeStamp + count,
          },
        })
      })
      adds.push({
        id: gift.variantId,
        quantity: gift.quantity || 1,
        properties: {
          _bundleStamp: timeStamp + count,
          _bundleGift: true,
        },
      })
      adds[0].properties._bundleMain = true
      adds[0].properties._bundleType = 1
      items = [...items, ...adds]
      count++
    }
    window.windowLoading(true)
    window
      .addToCart(items)
      .then(async () => {
        window.refreshCart(true)
        windowLoading(false)
      })
      .then(() => {
        callback()
      })
    // fetch('/cart/add.js', {
    //   method: 'POST',
    //   headers: {
    //     'content-type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     items,
    //   }),
    // })
    //   .then(res => res.json())
  }
}

customElements.define('hxz-add-button-block', HxzAddButtonBlock)

class HxzVirtualMakeupEntry extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id')
    if (this.productId) {
      this.eventBind()
    }
  }
  eventBind() {
    this.addEventListener('click', () => {
      const value = this.eventReduce(
        window.hxzEventMap.variantSelectGet(this.productId)
      )
      if (value.selectedVariant) {
        if (this.checkHasVirtual(value.selectedVariant)) {
          this.open(value.selectedVariant)
        }
      } else {
        // bundle情况
        let target = value.variants.find(
          item => item.productId == this.productId
        )
        if (target) {
          let variantId = target.variantId
          if (this.checkHasVirtual(variantId)) {
            this.open(variantId)
          }
        }
      }
    })
    this.eventOn(
      window.hxzEventMap.variantSelectChange(this.productId),
      value => {
        if (value && value.selectedVariant) {
          if (this.checkHasVirtual(value.selectedVariant)) {
            this.hide(false)
          } else {
            this.hide(true)
          }
        } else {
          this.hide(true)
        }
      }
    )
  }
  checkHasVirtual(variantId) {
    if (!this.variants) {
      const json = this.querySelector('.virtual-json')
      if (json) {
        this.variants = JSON.parse(json.textContent)
      }
    }
    let target = this.variants.find(v => v.variantId == variantId)
    if (target) {
      return !!target.skuId
    }
  }
  open(variantId) {
    if (!this.variants) {
      const json = this.querySelector('.virtual-json')
      this.variants = []
      if (json) {
        this.variants = JSON.parse(json.textContent)
      }
    }
    let variant = this.variants.find(v => v.variantId == variantId)
    if (variant) {
      this.eventEmit(window.hxzEventMap.virtualVisibleOpen, {
        type: this.variants.length > 1 ? 2 : 1,
        productId: this.productId,
        variantId: variantId,
        lookIndex: 0,
        list: [...this.variants],
      })
    }
  }
  hide(value) {
    if (value) {
      this.classList.add('-hidden')
    } else {
      this.classList.remove('-hidden')
    }
  }
}
customElements.define('hxz-virtual-makeup-entry', HxzVirtualMakeupEntry)

class HxzDiscountBlock extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id')
    let discountStorage = localStorage.getItem('temp-discount')
    if (discountStorage) {
      localStorage.removeItem('temp-discount')
      const [productId, code] = discountStorage.split(':')
      if (this.productId == productId) {
        this.style.display = 'block'
        this.eventOn(
          window.hxzEventMap.productAddCart(this.productId),
          data => {
            return {
              ...data,
              discountCode: code,
            }
          }
        )
      }
    }
  }
}

customElements.define('hxz-discount-block', HxzDiscountBlock)

// 产品详情页,sku轩窗组件
class HxzVariantOption extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id')
    this.title = this.getAttribute('data-title')
    this.sku = this.getAttribute('data-sku')
    this.variantId = this.getAttribute('data-variant-id')
    this.available = this.getAttribute('data-available') == 'true'
    this.active = this.classList.contains('active')
    this.price = this.getAttribute('data-price')
    this.filterString = this.getAttribute('data-filter')
    this.filterPrefix = this.getAttribute('data-filter-prefix') || '' // 过滤器事件前缀
    this.eventBind()
  }
  eventBind() {
    this.eventOn(
      window.hxzEventMap.variantOptionClick(this.productId),
      value => {
        if (value.variantId != this.variantId) {
          this.active = false
          this.classList.remove('active')
        } else {
          this.active = true
          this.classList.add('active')
        }
      }
    )
    this.addEventListener('click', () => {
      this.clickFn()
    })
    if (this.filterString && this.filterPrefix) {
      let filters = this.filterString.split('||').filter(f => f)
      if (filters && filters.length > 1) {
        this.eventOn(
          window.hxzEventMap.variantFilterGet(
            `${this.filterPrefix}-${this.productId}`
          ),
          data => {
            let shouldHide = false
            if (data.filter.length > 0) {
              // 全包含
              for (let filter of data.filter) {
                if (!filters.includes(filter)) {
                  shouldHide = true
                  break
                }
              }
            }
            if (shouldHide) {
              this.classList.add('-hidden')
              return {
                ...data,
              }
            } else {
              this.classList.remove('-hidden')
              return {
                ...data,
                count: data.count + 1,
                selectedCallback: data.selectedCallback
                  ? data.selectedCallback
                  : this.clickFn.bind(this),
              }
            }
          }
        )
      }
    }
  }
  clickFn() {
    if (this.active) return
    this.eventEmit(
      window.hxzEventMap.variantOptionClick(this.productId),
      this.getValue()
    )
  }
  getValue() {
    return {
      productId: this.productId,
      variantId: this.variantId,
      available: this.available,
      price: this.price,
      title: this.title,
      sku: this.sku,
    }
  }
}

customElements.define('hxz-variant-option', HxzVariantOption)

class HxzPriceBlock extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id')
    this.initPrice = this.getAttribute('data-init-price')
    this.renderLike()
    this.renderShare()
    this.eventBind()
  }
  eventBind() {
    this.eventOn(
      window.hxzEventMap.variantSelectChange(this.productId),
      value => {
        if (value && value.variants) {
          this.changePrice(value.variants)
        }
      }
    )
    setTimeout(() => {
      const value = this.eventReduce(
        window.hxzEventMap.variantSelectGet(this.productId)
      )
      if (value.variants) {
        this.changePrice(value.variants)
      }
    }, 0)
  }
  // value:[{variantId:string,price:string,available:boolean,quantity:number}]
  changePrice(value) {
    let list = value.filter(item => item.quantity > 0)
    if (list.length == 1) {
      this.querySelector('.price').innerText = list[0].price
    } else {
      this.querySelector('.price').innerText = this.initPrice
    }
  }
  renderLike() {
    this.like = this.querySelector('.like')
    if (this.like) {
      if (!window.USERID) {
        this.like.style.display = 'none'
      } else {
        // 查询是否收藏
        fetch(
          `/a/choogo/lts/api/v1/click/list/page?pageNo=1&pageSize=1&clickType=collect&clickBiz=product&bizId=${this.productId}&userId=${window.USERID}`,
          {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
          }
        )
          .then(res => res.json())
          .then(res => {
            if (res.code !== 200) return
            if (res.data.records.length > 0) {
              const likedClick = res.data.records[0].clickId
              this.collectId = likedClick
              this.like.classList.add('active')
            }
          })
          .then(() => {
            this.like.addEventListener('click', () => {
              this.doCollect()
            })
          })
      }
    }
  }
  renderShare() {
    this.share = this.querySelector('.share')
    if (this.share) {
      if (navigator.share) {
        this.share.style.display = 'block'
        // 事件绑定
        this.share.addEventListener('click', () => {
          navigator.share({
            title: document.title,
            url: window.location.href,
          })
        })
      } else {
        this.share.style.display = 'none'
      }
    }
  }
  doCollect() {
    if (!window.USERID) return
    let collected = this.like.classList.contains('active')
    if (collected) {
      fetch(`/a/choogo/lts/api/v1/click/delete/${this.collectId}`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
      })
        .then(res => res.json())
        .then(res => {
          if (res.code !== 200) return
          this.like.classList.remove('active')
        })
    } else {
      fetch(`/a/choogo/lts/api/v1/click/add`, {
        method: 'POST',
        headers: { 'content-type': 'application/json', station: 'test' },
        body: JSON.stringify({
          bizId: this.productId,
          clickBiz: 'product',
          clickType: 'collect',
          userId: window.USERID,
        }),
      })
        .then(res => res.json())
        .then(res => {
          if (res.code !== 200) return
          this.like.classList.add('active')
        })
    }
  }
}
customElements.define('hxz-price-block', HxzPriceBlock)

/**
 * 产品详情页竖向轮播
 */
class HxzGallery extends EventBusHTMLElement {
  constructor() {
    super()
    this.created = false
  }
  connectedCallback() {
    this._currentId = this.getAttribute('data-current-id')
    this.productId = this.getAttribute('data-product-id')
    this.init()
    this.eventBind()
  }
  init() {
    // mediaMap: {id: [{src: '', type: ''}]}
    const json = this.querySelector('.product-gallery-json')
    if (json) {
      this.mediaMap = JSON.parse(json.textContent)
    }
  }
  eventBind() {
    setTimeout(() => {
      const value = this.eventReduce(
        window.hxzEventMap.variantSelectGet(this.productId)
      )
      if (value.selectedVariant) {
        if (value.selectedVariant != this.currentId) {
          this.currentId = value.selectedVariant
        } else if (this.created == false) {
          this.observe()
          this.created = true
        }
      } else if (this.created == false) {
        this.observe()
        this.created = true
      }
    }, 0)
    this.eventOn(
      window.hxzEventMap.variantSelectChange(this.productId),
      value => {
        if (
          value &&
          value.selectedVariant &&
          value.selectedVariant != this.currentId
        ) {
          this.currentId = value.selectedVariant
        }
      }
    )
  }
  get currentId() {
    return this._currentId
  }
  set currentId(value) {
    if (value != this._currentId) {
      this._currentId = value
      const checkScrollEnd = () => {
        let lastPosition = window.pageYOffset
        let ticking = false

        const update = () => {
          const currentPosition = window.pageYOffset

          if (currentPosition === 0) {
            this.render()
            window.removeEventListener('scroll', onScroll)
            return
          }

          if (lastPosition !== currentPosition) {
            lastPosition = currentPosition
            ticking = false
            requestAnimationFrame(update)
          }
        }

        function onScroll() {
          if (!ticking) {
            ticking = true
            requestAnimationFrame(update)
          }
        }

        window.addEventListener('scroll', onScroll)
        requestAnimationFrame(update)
      }
      checkScrollEnd()
      // 丝滑的滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
  render() {
    const mediaArr = this.mediaMap[this.currentId]
    if (mediaArr) {
      this.renderDots(mediaArr.length)
      this.renderMedia(mediaArr)
      this.observe()
    }
  }
  renderMedia(mediaArr) {
    let container = this.querySelector('.media-container')
    if (container) {
      let mediaHtml = ''
      mediaArr.forEach(item => {
        mediaHtml += `
        <div class="-h-auto -flex-shrink-0 -flex-grow-0 -mdx:-h-hxz-main -flex-center -w-full">
          ${this.getMediaStr(item)}
        </div>
        `
      })
      container.innerHTML = mediaHtml
    }
  }
  renderDots(length) {
    let container = this.querySelector('.dot-container')
    if (container) {
      let dotHtml = ''
      for (let i = 0; i < length; i++) {
        dotHtml += `
        <div class="-w-20 -h-20 -p-4 dot -group -cursor-pointer ${
          i == 0 ? 'active' : ''
        }">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M10.6874 8.35466L10.704 8.34639C11.0764 8.06501 11.3743 7.70087 11.5729 7.2788C11.7716 6.85673 11.8792 6.40156 11.8709 5.93811C11.8709 5.49122 11.7633 5.0526 11.5729 4.65535C11.3826 4.25811 11.0929 3.90225 10.7454 3.62915C9.86812 2.90087 9.04881 2.09811 8.30398 1.23742C8.0226 0.889837 7.66674 0.616734 7.2695 0.426389C6.86398 0.236044 6.42536 0.136734 5.98674 0.14501H5.95364C5.54812 0.14501 5.1426 0.236044 4.76191 0.401561C4.3895 0.567079 4.05019 0.807079 3.77709 1.10501L3.76881 1.11329C3.7026 1.17949 3.64467 1.25398 3.58674 1.32846V1.33673V1.34501C2.89985 2.16432 2.14674 2.9257 1.34398 3.63742V3.6457L1.2364 3.6788C0.880535 3.96018 0.599156 4.32432 0.408811 4.72984C0.218466 5.14363 0.119156 5.59053 0.127432 6.0457C0.127432 6.46777 0.218466 6.88984 0.400535 7.27053C0.574328 7.65122 0.83088 7.9988 1.15364 8.27191C2.08881 9.04156 2.95778 9.8857 3.75226 10.8043C4.03364 11.1354 4.3895 11.4085 4.79502 11.5905C5.19226 11.7726 5.63088 11.8636 6.0695 11.8554C6.49985 11.8554 6.92191 11.756 7.31088 11.5823C7.69985 11.4002 8.04743 11.1354 8.32054 10.8126L8.39502 10.7216C9.09019 9.87742 9.85985 9.08294 10.6874 8.35466Z" class="group-[.active]:-block -hidden" fill="#003B4A"/>
            <path d="M11.1205 7.06591C10.9632 7.40024 10.7299 7.69129 10.4373 7.92071L10.4058 7.93646L10.3571 7.97931C9.50968 8.72505 8.72138 9.53874 8.00905 10.4037L8.00804 10.4049L7.9363 10.4926C7.71187 10.757 7.4249 10.9761 7.10285 11.1276C6.77277 11.2744 6.42136 11.3554 6.0695 11.3554V11.3553L6.06007 11.3554C5.69609 11.3623 5.33194 11.2866 5.00335 11.136L4.99981 11.1344C4.66464 10.9839 4.36827 10.757 4.13323 10.4805L4.13324 10.4805L4.13044 10.4772C3.31783 9.53767 2.42949 8.67464 1.47416 7.88814C1.21181 7.66549 0.999817 7.37927 0.855379 7.06288L0.855451 7.06285L0.851602 7.0548C0.703334 6.74478 0.627432 6.39688 0.627432 6.0457H0.627514L0.627349 6.03661C0.620528 5.66145 0.702063 5.28943 0.862246 4.94055C1.0213 4.60236 1.25493 4.30157 1.54651 4.07101L1.56588 4.0557L1.57329 4.04854C1.57926 4.04419 1.59213 4.03547 1.61106 4.02601C1.67086 3.99611 1.72172 3.95444 1.73378 3.94456C1.7345 3.94397 1.73508 3.9435 1.73552 3.94315C1.75932 3.92387 1.78585 3.90105 1.81299 3.87709C1.86794 3.82857 1.93815 3.76405 2.01849 3.68852C2.17984 3.53685 2.3908 3.33252 2.61928 3.10494C3.07333 2.65268 3.61153 2.0937 3.9699 1.66624L4.08674 1.52688V1.50497C4.09889 1.49117 4.11057 1.47863 4.12236 1.46684L4.13064 1.45856L4.13832 1.45088L4.14566 1.44287C4.36988 1.19827 4.6514 0.998132 4.96313 0.85929C5.28623 0.719089 5.62348 0.64501 5.95364 0.64501H5.98674V0.645099L5.99617 0.644921C6.35241 0.638199 6.71479 0.718673 7.05525 0.878163C7.38875 1.03828 7.68376 1.26592 7.91536 1.55202L7.92053 1.5584L7.9259 1.56461C8.68869 2.44606 9.52764 3.26806 10.426 4.01385L10.4259 4.01399L10.4365 4.02231C10.7259 4.24975 10.966 4.54576 11.122 4.87142C11.2825 5.20619 11.3709 5.57133 11.3709 5.93811H11.3708L11.371 5.94704C11.3777 6.32648 11.2898 6.70613 11.1205 7.06591Z" class="group-[.active]:-hidden -block" stroke="#003B4A"/>
          </svg>
        </div>
        `
      }
      container.innerHTML = dotHtml
      // 监听页面滑动的高度
    }
  }
  observe() {
    let medias = this.querySelectorAll('.media-container .hxz-media')
    if (medias.length == 0) return
    let dots = this.querySelectorAll('.dot-container .dot')
    medias.forEach((item, index) => {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              dots.forEach((dot, i) => {
                if (i == index) {
                  return dot.classList.add('active')
                }
                return dot.classList.remove('active')
              })
            }
          })
        },
        {
          threshold: 0.5, // 设置阈值为 0.5，表示元素至少有 50% 可见时触发回调
        }
      )

      // 开始观察目标元素
      observer.observe(item)
    })
    dots.forEach((item, index) => {
      item.addEventListener('click', () => {
        medias[index].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      })
    })
  }
  getMediaStr(item) {
    if (item.type === 'image') {
      return `<div class="-aspect-[4/5] hxz-media -mdx:-max-h-[95%] -w-full -mdx:-w-auto -mdx:-max-w-full">
      <hxz-image zoom="2" full-screen  src="${item.src}" ratio="0.5" max-width="850"></hxz-image>
      </div>`
    } else if (item.type === 'video') {
      const target = this.getVideo(item.id)
      if (target) {
        return `
        <video class="-aspect-[4/5] hxz-media -mdx:-max-h-[95%] -w-full -mdx:-w-auto -mdx:-max-w-full" controls="controls" loop="loop" preload="metadata" poster="${target.poster}">
          <source src="${target.url}" type="video/mp4">
          <img src="${target.poster}">
        </video>`
      }
      return ''
    }
  }
  getVideo(id) {
    const template = this.querySelector('.hxz-product-gallery-template')
    if (!template) return null
    const videoEl = template.content.querySelector(`[id="${id}"]`)
    if (videoEl) {
      const url = videoEl.querySelector('source').src
      const poster = videoEl.querySelector('img').src
      return {
        url,
        poster,
      }
    }
    return null
  }
}

customElements.define('hxz-gallery', HxzGallery)

/**
 * type: 打开sku选择器的方式 drawer | max-height
 * data-product-id: 产品id
 */
class HxzStickySkuArea extends EventBusHTMLElement {
  constructor() {
    super()
    this.container = null
    this.productId = null
    this.dotsEl = []
  }
  connectedCallback() {
    this.type = this.getAttribute('data-type') || 'drawer'
    this.productId = this.getAttribute('data-product-id') || null
    if (!this.productId) return
    this.currentVariant = this.getAttribute('data-init-variant') || null
    const json = this.querySelector(
      '.product_variant_json[type="application/json"]'
    )
    if (json) {
      this.variants = JSON.parse(json.textContent)
    }
    const options = this.querySelector(
      '.product_options_json[type="application/json"]'
    )
    if (options) {
      this.options = JSON.parse(options.textContent)
    }
    this.render()
    this.eventBind()
  }
  render() {
    let skuIcon = this.querySelector('.sku-icon')
    let variant = this.variants.find(item => item.id == this.currentVariant)
    let template = this.querySelector('template[class="dot-picker"]').content
    if (skuIcon) {
      let node = null
      if (variant.skuColor) {
        node = template.querySelector('.dot-picker-color').cloneNode(true)
        node.querySelector('.dot').style.fill = variant.skuColor
      } else {
        node = template.querySelector('.dot-picker-image').cloneNode(true)
        node.querySelector('.dot').setAttribute('href', variant.skuImage)
      }
      skuIcon.innerHTML = ''
      skuIcon.appendChild(node)
    }
    let skuNames = this.querySelectorAll('.sku-name')
    if (skuNames.length > 0) {
      for (let skuName of skuNames) {
        skuName.innerHTML = variant.title
      }
    }
  }
  eventBind() {
    let skuSelect = this.querySelector('.sku-select')
    if (skuSelect) {
      if (this.type == 'drawer') {
        this.bindDrawer(skuSelect)
      }
      if (this.type == 'max-height') {
        this.bindArea(skuSelect)
      }
    }
    // 接受主选择器变动
    this.eventOn(
      window.hxzEventMap.variantSelectChange(this.productId),
      value => {
        if (
          value.selectedVariant &&
          value.selectedVariant != this.currentVariant
        ) {
          this.currentVariant = value.selectedVariant
          this.render()
        }
      }
    )
  }
  bindDrawer(el) {
    el.addEventListener('click', () => {
      let eventId = new Date().getTime() + this.productId
      let drawer = document.createElement('hxz-variant-picker-drawer')
      drawer.setAttribute('data-variants', JSON.stringify(this.variants))
      drawer.setAttribute('data-event-id', eventId)
      drawer.setAttribute('data-current-variant', this.currentVariant)
      if (this.options) {
        drawer.setAttribute('data-options', JSON.stringify(this.options))
      }
      this.eventOn(window.hxzEventMap.productSkuChange(eventId), variantId => {
        this.eventOff(window.hxzEventMap.productSkuChange(eventId))
        if (variantId) {
          this.changeSelect(variantId)
        }
      })
      document.body.appendChild(drawer)
    })
  }
  bindArea(el) {
    let area = this.querySelector('.bar_sku-area')
    // let filterEl = this.querySelector('.variant-filter')
    el.addEventListener('click', () => {
      // 展开sku选择器
      area.style.height = 'max-content'
      area.style.opacity = '1'
      // if (filterEl) {
      //   this.bindFilter()
      // }
    })
    let closeButton = this.querySelector('.close-icon')
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        // 关闭sku选择器
        area.style.height = '0'
        area.style.opacity = '0'
        // if (filterEl) {
        //   this.cancelFilter()
        // }
      })
    }
  }
  bindAvailableDot(el, variant) {
    el.addEventListener('click', () => {
      this.changeSelect(variant.id)
    })
  }
  changeSelect(variantId) {
    if (this.currentVariant != variantId) {
      let variant = this.variants.find(item => item.id == variantId)
      // 提示主选择器，模拟主选择器点击事件
      this.eventEmit(window.hxzEventMap.variantOptionClick(this.productId), {
        ...variant,
        productId: this.productId,
        variantId: variant.id,
      })
    }
  }
  // bindFilter() {
  //   this.filters = []
  //   this.filterListener = e => {
  //     let filter = e.detail
  //     let target = this.filters.find(f => f.label == filter.label)
  //     if (target) {
  //       if (target.value == filter.value) return
  //       target.value = filter.value
  //     } else {
  //       this.filters.push(filter)
  //     }
  //     this.filtersChange(this.filters, true)
  //   }
  //   this.addEventListener('select-change', this.filterListener)
  // }
  // cancelFilter() {
  //   this.filters = []
  //   this.filtersChange(this.filters, false)
  //   this.removeEventListener('select-change', this.filterListener)
  // }
  // filtersChange(filters, autoSelect) {
  //   let filterValue = filters.map(f => f.value).filter(v => v != 'all')
  //   let data = this.eventReduce(
  //     window.hxzEventMap.variantFilterGet(`sku-area-${this.productId}`),
  //     { count: 0, selectedCallback: null, filter: filterValue }
  //   )
  //   if (data.selectedCallback && autoSelect) {
  //     data.selectedCallback()
  //   }
  // }
}
customElements.define('hxz-sticky-sku-area', HxzStickySkuArea)

// 监听页面 hxz-add-button-block 元素是否可见
class HxzProductStickyBar extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.type = this.getAttribute('type')
    if (this.type == 'pc') {
      let el = document.querySelector('hxz-add-button-block')
      if (el) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.classList.add('-mdx:-hidden')
                this.classList.remove('-mdx:-block')
              } else {
                // 视口外且向下滚动导致的不可见
                if (entry.boundingClientRect.top > 100) {
                  this.classList.add('-mdx:-hidden')
                  this.classList.remove('-mdx:-block')
                } else {
                  this.classList.remove('-mdx:-hidden')
                  this.classList.add('-mdx:-block')
                }
              }
            })
          },
          {
            rootMargin: '-62px 0px 0px 0px',
            threshold: '0', // 设置阈值为 0.5，表示元素至少有 50% 可见时触发回调
          }
        )
        observer.observe(el)
      }
    }
  }
}

customElements.define('hxz-product-sticky-bar', HxzProductStickyBar)

class HxzProductRecommendBlock extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.expand = this.getAttribute('data-expand') == 'true' ? true : false
    let expandIcon = this.querySelector('.expand-icon')
    let expandArea = this.querySelector('.expand-area')
    if (expandIcon) {
      expandIcon.addEventListener('click', () => {
        this.expand = !this.expand
        if (this.expand) {
          expandIcon.style.transform = 'rotate(180deg)'
          expandArea.style.height = 'max-content'
        } else {
          expandIcon.style.transform = 'rotate(0deg)'
          expandArea.style.height = '0'
        }
      })
    }
  }
}
customElements.define('hxz-product-recommend-block', HxzProductRecommendBlock)

// 产品详情页,组套产品的变体选择器，用于子品的sku选择
class HxzVariantBlockBundle extends EventBusHTMLElement {
  constructor() {
    super()
    this.productId = ''
    this.variantId = ''
    this.available = false
  }
  connectedCallback() {
    this.productId = this.getAttribute('data-product-id') || ''
    this.variantId = this.getAttribute('data-variant-id') || ''
    this.available = this.getAttribute('data-available') == 'true'
    this.evenBind()
  }
  evenBind() {
    // 监听加购按钮的获取事件
    this.eventOn(window.hxzEventMap.variantSelectGet(this.productId), data => {
      return {
        ...data,
        singleBundle: this.getValue(),
      }
    })
    // 监听加购事件
    this.eventOn(window.hxzEventMap.productAddCart(this.productId), data => {
      return {
        ...data,
        singleBundle: this.getValue(),
      }
    })
    // 监听收起展开事件
    let expandIcon = this.querySelector('.expand-icon')
    let expandArea = this.querySelector('.expand-area')
    if (expandArea && expandIcon) {
      expandIcon.addEventListener('click', () => {
        if (expandIcon.hasAttribute('data-expand')) {
          expandIcon.removeAttribute('data-expand')
          expandArea.style.height = '0px'
          expandIcon.style.transform = 'rotate(0deg)'
        } else {
          expandIcon.setAttribute('data-expand', 'true')
          expandArea.style.height = 'max-content'
          expandIcon.style.transform = 'rotate(180deg)'
        }
      })
    }
    // 监听主品变化事件
    this.addEventListener('select-line-card-change', e => {
      e.stopPropagation()
      this.valueChange()
    })
    // 监听赠品变化事件
    this.addEventListener('select-card-change', e => {
      e.stopPropagation()
      this.valueChange()
    })
  }
  valueChange() {
    this.eventEmit(window.hxzEventMap.variantSelectChange(this.productId), {})
  }
  /**
   * @returns {
   *   variantId:string,
   *   available:boolean,
   *   bundle:[{variantId:string,available:boolean,productName:string,variantName:string}]
   * }
   */
  getValue() {
    if (!this.available) {
      return {
        variantId: this.variantId,
        available: false,
        bundle: [],
      }
    }
    let bundles = this.getBundleValue()
    let gifts = this.getGiftsValue()
    return {
      variantId: this.variantId,
      available: true,
      bundle: [...bundles, ...gifts],
    }
  }
  getBundleValue() {
    let lineCards = this.querySelectorAll('.bundle-area hxz-select-line-card')
    let values = Array.from(lineCards).map(card => card.getValue())
    return values.map(item => ({
      variantId: item.variantId,
      available: item.available,
      productName: item.productName,
      variantName: item.variantName,
    }))
  }
  getGiftsValue() {
    let giftCards = this.querySelectorAll('.gift-area hxz-select-card')
    let values = Array.from(giftCards).map(card => card.getValue())
    return values.map(item => ({
      variantId: item.variantId,
      available: item.available,
      productName: item.productName,
      variantName: item.variantName,
    }))
  }
}

customElements.define('hxz-variant-block-bundle', HxzVariantBlockBundle)
